import Card from "../UI/Card";
import styles from "./ExpenseDate.module.css";
const ExpenseDate = (props) => {
  const { date } = props;

  const formatYear = date.getFullYear();
  const formatMonth =
    date.toLocaleString("en-us", {
      month: "long",
    });
  const formatDay = date.toLocaleString(
    "en-us",
    {
      day: "numeric",
    }
  );
  return (
    <Card
      className={
        styles[
          "expenses-expenseList__expenseItem__expenseDate"
        ]
      }
    >
      <h3
        id={
          styles[
            "expenses-expenseList__expenseItem__expenseDate__month"
          ]
        }
      >
        {formatMonth}
      </h3>
      <h3
        id={
          styles[
            "expenses-expenseList__expenseItem__expenseDate__year"
          ]
        }
      >
        {formatYear}
      </h3>
      <h3
        id={
          styles[
            "expenses-expenseList__expenseItem__expenseDate__day"
          ]
        }
      >
        {formatDay}
      </h3>
    </Card>
  );
};

export default ExpenseDate;
